/**
 * Ensures the dynamic-inline-styles and dynamic-runtime-styles elements exist on client
 * so styleToClass / setDynamicRule can inject rules without using inline styles (CSP-safe).
 */
import { getOrCreateDynamicStyleElement, getOrCreateRuntimeStyleElement } from '~/utils/styleToClass.js'

export default function () {
  if (!process.client) return
  getOrCreateDynamicStyleElement()
  getOrCreateRuntimeStyleElement()
}
